<div class="new-proposal__fields new-proposal__fields--overview">

	<h3 i18n="@@proposals.proposal_overview">Proposal Overview</h3>
	<div class="new-proposal__fields--overview--TitleWrap"><span>{{ proposal.title }}</span></div>
	<div class="new-proposal__fields--overview--headerInfo">
		<div class="proposal-info">
			<span>
				<ng-container i18n="@@proposal">Proposal </ng-container>
				<strong>#{{ proposal.proposal_number }}</strong>
			</span>
			<span>
				<ng-container i18n="@@proposals.proposal_to">Proposal to </ng-container>
				<strong> : {{ clientDetail.full_name }}</strong>
			</span>
		</div>
		<div class="proposal-date" *ngIf="proposal.quote_date">
			<ng-container i18n="@@proposals.proposal_date">Proposal Date</ng-container>
			<strong> : {{ proposal.quote_date | date:'dd-MM-yyyy'}}</strong>
		</div>
	</div>

	<ul class="nav nav-tabs new-proposal__fields--overview--tabNav" id="myTab" role="tablist">
		<li class="nav-item">
			<a [class.active]="activeTab == 'project-detail'" (click)="switchTab('project-detail')" class="nav-link"
				id="project-details-tab" role="tab" aria-controls="project-details" aria-selected="true"
				i18n="@@proposals.project_details">Project Details</a>
		</li>
		<li class="nav-item">
			<a [class.active]="activeTab == 'quote'" (click)="switchTab('quote')" class="nav-link" id="quote-tab" role="tab"
				aria-controls="quote" aria-selected="false" i18n="@@proposals.quote">Quote</a>
		</li>
		<li class="nav-item">
			<a [class.active]="activeTab == 'terms'" (click)="switchTab('terms')" class="nav-link" id="termscondition-tab"
				data-toggle="tab" role="tab" aria-controls="termscondition" aria-selected="false"
				i18n="@@proposals.terms_and_condition">Terms &
				Condition</a>
		</li>
	</ul>

	<div class="tab-content" id="proposalOverview">

		<div class="tab-pane fade {{activeTab == 'project-detail' ? 'active show' : '' }}" id="project-details"
			role="tabpanel" aria-labelledby="project-details-tab">
			<div class="new-proposal__fields__wrap">
				<div
					class="new-proposal__fields__wrap--content"
					data-simplebar [ngClass]="">
					<div class="new-proposal__fields__wrap--content--inner">
						<p><strong i18n="@@proposals.project_description">Project Description</strong></p>
						<p class="pre-text">{{ proposal.description }}</p>

						<ng-container *ngIf="proposal.comments">
							<p><strong i18n="@@proposals.comments">Comments</strong></p>
							<p class="pre-text">{{ proposal.comments }}</p>
						</ng-container>
					</div>
				</div>
				
				<div class="new-proposal__fields__wrap--side">
					<div class="new-proposal__fields--project-details__sidebar--contentInner">
	          <label i18n="@@proposals.reference_files">Reference files</label>
	        </div>
		        
					<ng-container *ngIf="(projectDetail.new_files && projectDetail.new_files.length > 0) || (projectDetail.files && projectDetail.files.length); else noFiles">
						<div *ngFor="let file of projectDetail.files"  class="new-proposal__fields--project-details__sidebar--contentInner link-container">
		          <a *ngIf="file.path" [attr.href]="file.path" target="_blank" download>{{ file.name }}</a>
		          <a *ngIf="!file.path" href="javascript:void(0)">{{ file.name }}</a>
		        </div>

						<div *ngFor="let file of projectDetail.new_files"  class="new-proposal__fields--project-details__sidebar--contentInner link-container">
		          <a href="javascript:void(0)">{{ file.name }}</a>
		        </div>
		      </ng-container>

		      <ng-template #noFiles>
		      	<div class="new-proposal__fields--project-details__sidebar--contentInner link-container text-center">
						    <p class="text-center w-100 mb-0">No Files</p>
						</div>
		      </ng-template>

					<ng-container *ngIf="proposal.links && proposal.links.length">
						<div class="new-proposal__fields--project-details__sidebar--contentInner">
							<label i18n="@@proposals.links_to_inspiration">Links to Inspiration</label>
						</div>

						<div *ngFor="let link of proposal.links"
							class="new-proposal__fields--project-details__sidebar--contentInner link-container">
							<a [attr.href]="link" target="_blank">{{ link }}</a>
						</div>
					</ng-container>
				</div>
			</div>

		</div>
		<!-- End project details tab -->

		<div class="tab-pane fade {{activeTab == 'quote' ? 'active show' : '' }}" id="quote" role="tabpanel"
			aria-labelledby="quote-tab">
			<div *ngIf="proposal.deliverables && proposal.deliverables.length > 0 ; else noQuote" class="new-proposal__fields__wrap">
				<div class="new-proposal__fields__wrap--content new-proposal__fields__wrap--content--quote">
					<div class="quote-detail">
						<header class="quote-detail__header">
							<span class="quote-detail__header--title" i18n="@@proposals.deliverables">Deliverables</span>
							<span class="quote-detail__header--qty">
								<ng-container i18n="@@common.hrs" *ngIf="proposal.project_type == 'hourly';else qtyLabel">Hrs </ng-container>
								<ng-template i18n="@@common.qty" #qtyLabel>Qty</ng-template>
							</span>
							<span class="quote-detail__header--rate" i18n="@@proposals.rate">Rate</span>
							<span class="quote-detail__header--cost" i18n="@@proposals.cost">Cost</span>
						</header>
						<div class="quote-detail__content">
							<ul>
								<li *ngFor="let deliverable of proposal.deliverables; index as i">
									<span class="quote-detail__content--title"><span
											class="number">{{ i+1 }}</span>{{ deliverable.title }}</span>
									<span class="quote-detail__content--qty">{{ deliverable.quantity }}</span>
									<span class="quote-detail__content--rate">{{ deliverable.rate | myCurrency  }}</span>
									<span class="quote-detail__content--cost">{{ deliverableCost(deliverable) | myCurrency  }}</span>
								</li>
							</ul>
							<div class="quote-detail__content--total" [ngClass]="{'w-455':  proposal.tax_rate || proposal.total_amount > 999}">
								<div class="quote-detail__content--total-item">
									<ng-container i18n="@@proposals.total_amount">Total Amount</ng-container>
									<br *ngIf="proposal.tax_rate"><span>{{ proposal.total_amount | myCurrency  }}</span>
								</div>
								<div class="quote-detail__content--total-item" *ngIf="proposal.tax_rate">
									<ng-container i18n="@@proposals.tax">VAT</ng-container>
									({{proposal.tax_rate}}%)<br><span>{{ (proposal.total_amount * proposal.tax_rate/100) | myCurrency  }}</span>
								</div>
								<div class="quote-detail__content--total-item">
									<ng-container i18n="@@proposals.sub_total">Sub Total</ng-container>
									<br *ngIf="proposal.tax_rate"><span>{{ proposal.sub_total | myCurrency  }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="new-proposal__fields__wrap--side new-proposal__fields__wrap--side--quote">
					<div class="new-proposal__fields__wrap--side--quote--title" i18n="@@proposals.invoice_terms">Invoice Terms
					</div>
					<div class="new-proposal__fields__wrap--side--quote--content">
						<ng-container *ngIf="proposal.payment_info && proposal.payment_info.name; else noPaymentInfo">
							<span i18n="@@payment_info.payment_made_to">Payment to be made to</span>
							<span i18n="@@payment_info.name">Name:</span>
							<span><strong>{{ proposal.payment_info.name }}</strong></span>
							<span i18n="@@payment_info.iban">IBAN:</span>
							<span><strong>{{ proposal.payment_info.iban }}</strong></span>
							<span i18n="@@payment_info.account_number">Account number:</span>
							<span><strong>{{ proposal.payment_info.account_number }}</strong></span>
							<span i18n="@@payment_info.bank_name">Bank Name:</span>
							<span><strong>{{ proposal.payment_info.bank_name }}</strong></span>
							<span i18n="@@payment_info.country">Country:</span>
							<span><strong>{{ proposal.payment_info.country }}</strong></span>
						</ng-container>

						<ng-template #noPaymentInfo>
							<span>Payment information is not added.</span>
						</ng-template>
					</div>
				</div>
			</div>

			<ng-template #noQuote>
				<div class="new-proposal__fields__wrap justify-content-center p-5">
					<span i18n="@@proposals.you_skipped_message">This section has been skipped by you.</span>
				</div>
			</ng-template>
		</div>
		<!-- End quote tab -->

		<div class="tab-pane fade {{activeTab == 'terms' ? 'active show' : '' }}" id="termscondition" role="tabpanel"
			aria-labelledby="termscondition-tab">
			<div *ngIf="terms; else noTerms" class="new-proposal__fields__wrap">
				<div class="new-proposal__fields__wrap--content new-proposal__fields__wrap--content--termsCondition"
					data-simplebar>
					<div class="new-proposal__fields__wrap--content--inner">
						<div *ngFor="let termGroup of getObjectValues(terms)"
							class="new-proposal__fields__wrap--content--inner--section">
							<p><strong>{{termGroup.title}}</strong></p>
							<p class="pre-text" *ngFor="let term of getObjectValues(termGroup.terms)">{{term.description}}</p>
						</div>
					</div>
				</div>
			</div>

			<ng-template #noTerms>
				<div class="new-proposal__fields__wrap justify-content-center p-5">
					<span i18n="@@proposals.you_skipped_message">This section has been skipped by you.</span>
				</div>
			</ng-template>
		</div>
		<!-- End terms tab -->
	</div>

	<div class="new-proposal__controlsBTN fullTwoColumn">
		<div>
			<a (click)="triggerPrevious.emit()" href="javascript:void(0)" class="tu-btn transparent mb-2"
				i18n="@@proposals.back">Back</a>
			<a (click)="save('pdf')" href="javascript:void(0)" class="tu-btn transparent" i18n="@@proposals.save_as_pdf">Save
				as PDF</a>
			<a *ngIf="!proposalData.invoice_id" (click)="save('draft')" href="javascript:void(0)" class="tu-btn transparent"
				i18n="@@button.save_as_draft">Save as Draft</a>
		</div>

		<div>
			<a (click)="save()" href="javascript:void(0)" class="tu-btn blue mb-2" i18n="@@button.save">Save</a>
			<a *ngIf="clientDetail.email" (click)="save('email')" href="javascript:void(0)" class="tu-btn pink next_btn"
				i18n="@@common.email">Email</a>

			<button (click)="save('whatsapp')" type="button" class="tu-btn icon-left transparent whatsapp" id="btn-whatsapp">
        <svg style="width:23px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 478.165 478.165">
          <g>
              <path id="WhatsApp" class="icon-path whatsapp" d="M478.165,232.946c0,128.567-105.057,232.966-234.679,232.966c-41.102,0-79.814-10.599-113.445-28.969
                  L0,478.165l42.437-125.04c-21.438-35.065-33.77-76.207-33.77-120.159C8.667,104.34,113.763,0,243.485,0
                  C373.108,0,478.165,104.34,478.165,232.946z M243.485,37.098c-108.802,0-197.422,87.803-197.422,195.868
                  c0,42.915,13.986,82.603,37.576,114.879l-24.586,72.542l75.849-23.968c31.121,20.481,68.457,32.296,108.583,32.296
                  c108.723,0,197.323-87.843,197.323-195.908C440.808,124.921,352.208,37.098,243.485,37.098z M361.931,286.62
                  c-1.395-2.331-5.22-3.746-10.898-6.814c-5.917-2.849-34.089-16.497-39.508-18.37c-5.16-1.913-8.986-2.849-12.811,2.829
                  c-4.005,5.638-14.903,18.629-18.23,22.354c-3.546,3.785-6.854,4.264-12.552,1.435c-5.618-2.809-24.267-8.866-46.203-28.391
                  c-17.055-15.042-28.67-33.711-31.997-39.508c-3.427-5.758-0.398-8.826,2.471-11.635c2.69-2.59,5.778-6.734,8.627-10.041
                  c2.969-3.287,3.905-5.638,5.798-9.424c1.913-3.905,0.936-7.192-0.478-10.141c-1.415-2.849-13.01-30.881-17.752-42.337
                  c-4.841-11.416-9.543-9.523-12.871-9.523c-3.467,0-7.212-0.478-11.117-0.478c-3.785,0-10.041,1.395-15.381,7.192
                  c-5.2,5.658-20.123,19.465-20.123,47.597c0,28.052,20.601,55.308,23.55,59.053c2.869,3.785,39.747,63.197,98.303,86.07
                  c58.476,22.872,58.476,15.321,69.115,14.365c10.38-0.956,34.069-13.867,38.811-27.096
                  C363.345,300.307,363.345,288.991,361.931,286.62z"></path>
          </g>
        </svg>
        Whatsapp
      </button>	
		</div>
	</div>

</div>